import { Button } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { PrinterFilled } from '@ant-design/icons';

import './PrintEstimateButton.scss';

interface PrintEstimateButtonProps {
    disabled: boolean;
    onClick: () => void;
    altButtonText?: string;
    isInternal?: boolean;
}

const PrintEstimateButton = ({
    disabled,
    onClick,
    altButtonText,
    isInternal,
}: PrintEstimateButtonProps): JSX.Element => {
    const { t } = useTranslation();

    return (
        <Button
            disabled={disabled}
            className={classNames(
                'print-button',
                { 'print-button__disabled': disabled },
                { 'print-button__isInternal': isInternal },
                { 'print-button__isExternal': !isInternal }
            )}
            // className={`print-button ${disabled ? 'print-button__disabled' : ''}`}
            onClick={onClick}
            type="primary"
            htmlType="submit"
        >
            <PrinterFilled /> {altButtonText ?? t('BUTTON.SAVE')}
        </Button>
    );
};

export default PrintEstimateButton;
